import { defineStore } from 'pinia';
import DataService from "@/service/DataService";

export const useEnabledStore = defineStore({
    id: 'enabled',
    state: () => ({
        portalTypeBooks: null,
    }),
    mutations: {
        setPortalType(state, status) {
            state.portalTypeBooks = status;
        },
    },
    actions: {
        async checkPortalType() {
            try {
                const { data } = await DataService.getModulesEnabled();
                // this.portalTypeBooks = true;
                this.portalTypeBooks = Array.isArray(data) && data.length === 1 && data[0] === "Books";
            } catch (error) {
                console.error(error);
            }
        },
    },
    getters: {
        isPortalTypeBooks(state) {
            return state.portalTypeBooks;
        },
    },
});
